<template>
  <div>
   <el-card class="box-card" style="padding-bottom: 20px;height: 85%;">
    <div slot="header" class="clearfix" style="text-align:left;">
      <a style="text-decoration:none;color:#337ab7;cursor:pointer;" @click="returnBack">返回</a>
      <span style="line-height: 36px;margin-left:780px;font-weight:bold;">提现</span>
      <el-button style="float:right;" type="primary" @click="addBank">编辑银行卡信息</el-button>
    </div>
    <div style="text-align:left;width:30%;margin:0 auto;">
      <p>
          <span class="d_left">银行类型：</span>
          <span>{{bankType}}</span>
      </p>
      <p>
          <span class="d_left">银行卡账号：</span>
          <span>{{bankAccountName}}</span>
      </p>
      <p>
          <span class="d_left">银行卡号：</span>
          <span>{{bankNum}}</span>
      </p>
      <p>
          <span class="d_left">提现金额：</span>
          <el-input type="text" v-model="money" placeholder="请输入提现金额" style="width:160px;"></el-input>
          <span @click="getAll" style="margin-left:15px;color:#20a0ff;font-size:14px;">全部</span>
      </p>
      <div style="text-align:center;">
          <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
   </el-card>
   <pu-add-bank :update-pwd-show="isShow" @closeEditPwd="closeEditPwd" :bank-id="bankId" :bank-type="bankType" :bank-num="bankNum" :bank-account="bankAccountName"></pu-add-bank>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import puAddBank from './puAddBank'

    export default {
      data () {
        return {
          bankId: '',
          bankType: '',
          bankNum: '',
          money: '',
          isShow: false,
          bankAccountName: ''
        }
      },
      created: function () {
        this.queryDeviceList()
      },
      methods: {
        queryDeviceList () {
          var that = this
          var params = {
          }
          $axios.get('/bank/getBank', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              that.bankId = res.resultData.bank.bank_id
              that.bankType = res.resultData.bank.bank_name
              that.bankNum = res.resultData.bank.bank_card
              that.bankAccountName = res.resultData.bank.bank_account_name
              sessionStorage.setItem('bankType', that.bankType)
              sessionStorage.setItem('bankNum', that.bankNum)
              sessionStorage.setItem('bankAccount', that.bankAccountName)
            } else {
            }
          }, function () {
          })
        },
        getAll () {
          this.money = (this.$route.query.money / 100).toFixed(2)
        },
        addBank () {
          this.isShow = true
        },
        closeEditPwd () {
          this.isShow = false
          this.queryDeviceList()
        },
        confirm () {
          var _this = this
          var params = {
            amount: _this.money * 100
          }
          $axios.post('/withdraw/requestWithdraw', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$message({
                message: '提现成功！',
                type: 'success'
              })
              _this.returnBack()
            } else {
              _this.$message({
                message: res.errorMessage,
                type: 'error'
              })
            }
          }, function () {
          })
        },
        returnBack () {
          this.$router.back(-1)
        }
      },
      components: {
        'pu-add-bank': puAddBank
      }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/page/financeMgr/withdraw.vue